import axios from "axios";
import { API } from "@/lib/constants";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pk_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      if (localStorage.getItem("pk_admin_token")) {
        localStorage.removeItem("pk_admin_token");
        window.dispatchEvent(new Event("pk-session-expired"));
      }
    }
    return Promise.reject(err);
  }
);

export const fetchArtworks = async (params = {}) => (await api.get("/artworks", { params })).data;
export const fetchArtwork = async (id) => (await api.get(`/artworks/${id}`)).data;
export const sendEnquiry = async (body) => (await api.post("/enquiries", body)).data;
export const adminLogin = async (body) => (await api.post("/auth/login", body)).data;
export const updateArtwork = async (id, body) => (await api.put(`/admin/artworks/${id}`, body)).data;
export const regenerateArtwork = async (id) => (await api.post(`/admin/artworks/${id}/regenerate`)).data;
export const deleteArtwork = async (id) => (await api.delete(`/admin/artworks/${id}`)).data;
export const fetchEnquiries = async () => (await api.get("/admin/enquiries")).data;
export const uploadArtwork = async (file) => {
  const form = new FormData();
  form.append("image", file);
  form.append("generate", "true");
  return (await api.post("/admin/artworks", form)).data;
};

export const fetchEvents = async () => (await api.get("/events")).data;
export const updateEvent = async (id, body) => (await api.put(`/admin/events/${id}`, body)).data;
export const deleteEvent = async (id) => (await api.delete(`/admin/events/${id}`)).data;
export const regenerateEvent = async (id) => (await api.post(`/admin/events/${id}/regenerate`)).data;
export const createEvent = async (file) => {
  const form = new FormData();
  if (file) {
    form.append("image", file);
    form.append("generate", "true");
  }
  return (await api.post("/admin/events", form)).data;
};

export const replaceArtworkImage = async (id, file) => {
  const form = new FormData();
  form.append("image", file);
  return (await api.post(`/admin/artworks/${id}/image`, form)).data;
};

export const addEventImage = async (id, file) => {
  const form = new FormData();
  form.append("image", file);
  return (await api.post(`/admin/events/${id}/images`, form)).data;
};

export const removeEventImage = async (id, path) =>
  (await api.delete(`/admin/events/${id}/images`, { params: { path } })).data;

export const assistArtwork = async (id, notes) =>
  (await api.post(`/admin/artworks/${id}/assist`, { notes })).data;

export const generateCarousel = async (id) =>
  (await api.post(`/admin/artworks/${id}/carousel`)).data;

export const generateCollectionCarousel = async (ids) =>
  (await api.post("/admin/carousels", { artwork_ids: ids })).data;

export const downloadCollectionZip = async (cid) => {
  const res = await api.get(`/admin/carousels/${cid}.zip`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `collection-carousel-${cid}.zip`;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadCarouselZip = async (id) => {
  const res = await api.get(`/admin/artworks/${id}/carousel.zip`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `carousel-${id}.zip`;
  a.click();
  URL.revokeObjectURL(url);
};

export const fetchSettings = async () => (await api.get("/settings")).data;
export const updateSettings = async (body) => (await api.put("/admin/settings", body)).data;
export const uploadPortfolioPdf = async (file) => {
  const form = new FormData();
  form.append("file", file);
  return (await api.post("/admin/portfolio-pdf", form)).data;
};
export const deletePortfolioPdf = async () => (await api.delete("/admin/portfolio-pdf")).data;
export const uploadSiteImage = async (kind, file) => {
  const form = new FormData();
  form.append("kind", kind);
  form.append("image", file);
  return (await api.post("/admin/settings/image", form)).data;
};
